import { useEffect } from 'react';

import { useSearchParams } from 'react-router';

import { broadcastAuthLogout } from '@/app/hooks/cross-tab-auth.hook';
import { useNavigateToLogin } from '@/app/hooks/navigate-to-login.hook';
import { useApplicationStore } from '@hooks/application/application-store.hook';

const Logout = () => {
  const setUser = useApplicationStore(({ setUser }) => {
    return setUser;
  });
  const [searchParams] = useSearchParams();
  const { navigateToLogin } = useNavigateToLogin();

  useEffect(() => {
    const returnTo = searchParams.get('returnTo') ?? undefined;

    broadcastAuthLogout();
    setUser(undefined);
    navigateToLogin(returnTo);
  }, [navigateToLogin, searchParams, setUser]);

  return null;
};

export default Logout;
